<template>
  <div>
    <b-card>
      <titleSection
        title="Aportaciones"
        subtitle="Conoce la inversión del programa"
        icon="DollarSignIcon"
      />
      <div
        v-for="(aportacion, index) in aportaciones"
        :key="index"
        class="m-2"
      >
        <h5 class="text-primary mb-75 mt-2">
          <b>{{ aportacion.concepto }}</b>
        </h5>
        <b-card-text>
          $ {{ aportacion.monto }}
        </b-card-text>
        <b-card-text>
          {{ aportacion.comentarios }}
        </b-card-text>
      </div>
      <div
        v-if="aportaciones.length === 0"
        class="m-2"
      >
        <b-card-text>
          Por favor, consulta con el área de servicios escolares para conocer las aportaciones del programa.
        </b-card-text>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    titleSection,
    BCard,
    BCardText,
  },
  props: {
    plan: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const aportaciones = ref([])
    const toast = useToast()
    const aportacion = () => {
      aportaciones.value = []
      getData({ action: 42, q: props.plan })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) aportaciones.value = response.data.data
        })
        .catch(err => toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición',
            text: err,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 }))
    }
    onMounted(() => {
      aportacion()
    })
    watch(() => props.plan, () => {
      aportacion()
    })

    return {
      aportaciones,
    }
  },
}
</script>
